import { render } from "./treeV3.vue?vue&type=template&id=c9d49ce8&scoped=true"
import script from "./treeV3.vue?vue&type=script&lang=js"
export * from "./treeV3.vue?vue&type=script&lang=js"

import "./treeV3.vue?vue&type=style&index=0&id=c9d49ce8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9d49ce8"]])

export default __exports__